import backendCommunicator from 'services/backendCommunicator';

import * as I from 'interfaces';

import {type Site, type WriteSite} from 'client';
import Alert from 'helpers/Alert';
import {type AxiosError} from 'axios';
import {DEFAULT_HARVEST_COST, DEFAULT_OPERATIONAL_COST, DEFAULT_STARTUP_COST} from 'appConstants';
import {type Dispatch, type MutableRefObject, type SetStateAction} from 'react';
import {type TFunction} from 'i18next';

const siteToSend = (
  planId: string,
  site: WriteSite,
  setCreateSite: Dispatch<SetStateAction<boolean>>,
  t: TFunction,
) => {
  if (site.name.length === 0) {
    Alert.warning(t('siteMustHaveName'));
    setCreateSite(false);
  } else {
    site.planId = planId;
    site.siteNumber = site.siteNumber && site.siteNumber?.length > 0 ? site.siteNumber : undefined;
    // site.mab = site.mab ? tonsToKilos(site.mab) : 0;
    return site;
  }
};

export const siteInitialState = (selectedSite: Site | undefined) => {
  return {
    planId: '',
    longitude: selectedSite?.longitude ? selectedSite?.longitude : 5,
    latitude: selectedSite?.latitude ? selectedSite?.latitude : 60,
    siteNumber: selectedSite?.siteNumber ? selectedSite?.siteNumber : '',
    name: selectedSite?.name ? selectedSite?.name : '',
    startupCost: selectedSite?.startupCost ?? DEFAULT_STARTUP_COST,
    operationalCost: selectedSite?.operationalCost ?? DEFAULT_OPERATIONAL_COST,
    harvestCost: selectedSite?.harvestCost ?? DEFAULT_HARVEST_COST,
    mab: selectedSite?.mab ?? [],
    regionId: selectedSite?.regionId ?? '',
  };
};

const addEditSiteBackendHandler = async ({
  planId,
  site,
  createUpdateSite,
  setCreateUpdateSite,
  operationAddEdit,
  inputMenuDispatch,
  siteId,
  communicationSuccess,
  t,
  isMounted,
}: IHandleCommunicationSite) => {
  const _site = createUpdateSite && siteToSend(planId, site, setCreateUpdateSite, t);
  const backendOperation = _site && backendOperator(operationAddEdit, _site, t, siteId);

  const response =
    backendOperation &&
    backendOperation
      .then((response) => {
        isMounted.current && response && communicationSuccess(response.data);
        inputMenuDispatch && inputMenuDispatch({type: I.inputMenuActionType.closeMenu});
        return response;
      })
      .catch((error: AxiosError) => {
        isMounted.current && Alert.error(error);
      })
      .finally(() => {
        if (isMounted.current) {
          setCreateUpdateSite(false);
        }
      });

  return await response;
};

export default addEditSiteBackendHandler;

const backendOperator = async (operationAddEdit, site: WriteSite, t: TFunction, siteId?: string | null) => {
  if (operationAddEdit === I.methodType.edit) {
    if (siteId) {
      return await backendCommunicator.updateSite(siteId, site);
    }
    Alert.warning(t('noSiteError'));
  } else {
    return await backendCommunicator.createSite(site);
  }
};

interface IHandleCommunicationSite {
  setCreateUpdateSite: Dispatch<SetStateAction<boolean>>;
  operationAddEdit: I.methodType;
  inputMenuDispatch: Dispatch<I.InputMenuAction>;
  planId: string;
  site: WriteSite;
  createUpdateSite: boolean;
  siteId?: string;
  communicationSuccess: (site: Site) => void;
  t: TFunction;
  isMounted: MutableRefObject<boolean>;
}
